// extracted by mini-css-extract-plugin
export default {"rewardLabelContainer":"RewardLabel__rewardLabelContainer___ZjDw28cy","small":"RewardLabel__small___yyUyUDti"};